import { formatOfferBtc } from '@/utils/offer-inbox'
import OfferUsd from './offer-usd'
import styles from './offer-dialog.module.css'
import BitcoinIcon from '@/icons/bitcoin-filled'
import notificationStyles from './offer-notifications.module.css'

export default function OfferAmount({ sats, showLabel = true, showApproximation = true, compact = false }: { sats: number; showLabel?: boolean; showApproximation?: boolean; compact?: boolean }) {
	return (
		<div className={styles.offerAmount}>
			{showLabel && <span>Offer Amount:</span>}
			<strong style={compact ? { display: 'inline-flex', alignItems: 'center', gap: 4 } : undefined}>
				{compact ? <>
                    <span className={notificationStyles.amountPill}><BitcoinIcon className="size-3 shrink-0" aria-hidden="true" />{formatOfferBtc(sats)}</span>
                    <span className={notificationStyles.amountPill}><OfferUsd sats={sats} compact showApproximation={showApproximation} /></span>
                </> : <>{formatOfferBtc(sats)} BTC <OfferUsd sats={sats} parentheses showApproximation={showApproximation} /></>}
			</strong>
		</div>
	)
}
